<template>
    <div class="page">
        <!-- 搜索 -->
        <div class="page-content">
            <!-- 列表数据 -->
            <el-table :data="shopProductClassifyList" row-key="id" border @selection-change="handleSelectionChange" size="small">
                <el-table-column :show-overflow-tooltip="true" align="center" prop="catalogName" label="商品目录"> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="productName" label="商品名称"> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="productPic" label="商品图片">
                    <template slot-scope="scope">
                        <div v-if="scope.row.productPic">
                            <div vertical-align:middle>
                                <img
                                    style="margin-left: 50%; transform: translate(-50%, 0)"
                                    :src="scope.row.productPic"
                                    alt=""
                                    class="w-15 h-20 log-img"
                                />
                            </div>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="shopPrice" label="商品价格"> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="createTime" label="更新时间"> </el-table-column>
                <el-table-column fixed="right" align="center" label="操作" width="200">
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="deleteShopProductClassify(scop.row.id)">
                                <Icon size="16" style="color: #409eff">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: #409eff">更新</span>
                            </div>
                            <div @click="deleteShopProductClassify(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelect from '@/components/gridselect/index.vue';
import GridSelectLi from '@/components/gridselect/gidselect.vue';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelectLi,
        GridSelect
    },
    props: ['id'],
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopProductClassifyList();
                this.getShopProductClassifyList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopProductClassifyList();
                this.getShopProductClassifyList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            typeId: '',
            viewDetails: '',
            queryForm: {
                // id: '', //id
                catalogId: '',
                productName: '', //商品id
                catalogName: '' //类别类型
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopProductClassifyState: 'add',
            shopProductClassifyStates: {
                add: '新建商品',
                check: '查看商品',
                edit: '修改商品'
            },

            multipleSelection: [],
            shopProduct: [],
            shopProductClassifyList: [{ viewDetails: '' }],
            shopProductList: [],
            shopProductClassifyArr: [],
            shopProductClassify: {
                id: '', //id
                productIdList: [], //商品id
                catalogId: '', //类别类型
                seq: ''
            },
            btnLoading: false,

            rules: {
                seq: [{ required: true, message: '商品级别不能为空', trigger: 'blur' }],
                productIdList: [{ required: true, message: '商品种类为空', trigger: 'blur' }],
                catalogId: [{ required: true, message: '类别类型不能为空', trigger: 'blur' }]
            }
        };
    },
    created() {
        this.carder();
        this.getShopProductClassifyList();
    },
    methods: {
        carder() {
            this.typeId = this.$route.query;
            this.viewDetails = this.$route.query.viewDetails;
            console.log(this.viewDetails);
            // console.log(this.typeId.typeId);
        },

        getValuebrandId(value) {
            this.shopProductClassify.productIdList = value;
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        resetShopProductClassifyList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopProductClassifyList = [];
        },
        resetDialog() {
            this.shopProductClassifyState = 'add';
            this.showDialog = false;
            this.queryForm = {
                catalogId: '',
                productName: '', //商品id
                catalogName: '' //类别类型
            };
            this.getShopProductClassifyList();
        },
        closeDialog() {
            this.shopProductClassify = {
                // id: '', //id
                productId: [], //商品id
                catalogId: '' //类别类型
            };
            this.$refs.shopProductClassifyForm.resetFields();
            this.showDialog = false;
        },
        editShop() {
            this.$router.push({
                path: '/shop/ShopClassify'
            });
        },
        submitForm() {
            if (this.shopProductClassifyState == 'add') {
                this.$refs.shopProductClassifyForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        this.shopProductClassify.catalogId = this.typeId.typeId;
                        console.log(this.shopProductClassify);
                        post(`/shop/shopProductCatalogList/addBatch`, { ...this.shopProductClassify }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopProductClassifyList();
                                this.resetDialog();
                                this.getShopProductClassifyList();
                            }
                        });
                    }
                });
            } else if (this.shopProductClassifyState == 'edit') {
                this.$refs.shopProductClassifyForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/shop/shopProductCatalogList/edit`, { ...this.shopProductClassify }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopProductClassifyList();
                                this.resetDialog();
                                this.getShopProductClassifyList();
                            }
                        });
                    }
                });
            }
        },
        addShopProductClassify() {
            this.showDialog = true;
            this.shopProductClassifyState = 'add';
        },
        checkShopProductClassify(shopProductClassifyId) {
            console.log(shopProductClassifyId);
            this.currentShopProductClassifyId = shopProductClassifyId;

            this.getShopProductClassifyById();
            this.showDialog = true;
            this.shopProductClassifyState = 'check';
        },
        editShopProductClassify(shopProductClassifyId) {
            console.log('shopProductClassify', shopProductClassifyId);
            if (shopProductClassifyId) {
                this.currentShopProductClassifyId = shopProductClassifyId;
                this.getShopProductClassifyById();
            } else {
                this.shopProductClassify = { ...this.shopProductClassify, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.shopProductClassifyState = 'edit';
        },
        deleteShopProductClassify(shopProductClassifyId) {
            let ids = '';
            if (shopProductClassifyId) {
                ids = shopProductClassifyId;
            } else {
                ids = this.multipleSelection.map((shopProductClassify) => shopProductClassify.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/shop/shopProductCatalogList/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopProductClassifyList();
                            this.getShopProductClassifyList();
                        }
                    });
                })
                .catch(() => {});
        },
        refreshShopProductClassifyList() {
            this.resetShopProductClassifyList();
            this.getShopProductClassifyList();
        },
        getShopProductClassifyList(query = {}) {
            this.loading = true;
            this.queryForm.catalogId = id;
            console.log(this.queryForm);
            get(`/shop/shopProductCatalogList/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then(
                (res) => {
                    this.loading = false;
                    if (res.success) {
                        console.log(this.shopProductClassifyList.viewDetails);
                        this.shopProductClassifyList = res.page.list;
                        console.log(this.shopProductList);
                        this.totalNum = res.page.total;
                    }
                }
            );
        },
        getShopProductClassifyById() {
            get(`/shop/shopProductCatalogList/get`, { id: this.currentShopProductClassifyId }).then((res) => {
                if (res.success) {
                    this.shopProductClassify = { ...this.shopProductClassify, ...res.shopProductClassify };
                }
            });
        },

        exportShopProductClassifyList() {
            exprotExcel(`/mpp/shopproductclassify/export`, { ...this.queryForm });
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/shop/shopProductCatalogList/importData`, formData);
            this.refreshShopProductClassifyList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getShopProductClassifyList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getShopProductClassifyList();
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>
